import { render, staticRenderFns } from "./WxAuth.vue?vue&type=template&id=65539f19&scoped=true&"
import script from "./WxAuth.vue?vue&type=script&lang=js&"
export * from "./WxAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65539f19",
  null
  
)

export default component.exports